import React from 'react'

import { Subselect } from '../../../Subselect'
import { Input } from '../..'

import { Container } from './styles'

export const InputSelect = ({
  name,
  label,
  items,
  selectDefaultValue,
  mask,
  error,
  register,
  onChange,
}) => {
  return (
    <Container>
      <Subselect
        onValueChange={onChange}
        label="DDIs"
        name="DDIs"
        data={items}
        defaultValue={selectDefaultValue}
      />
      <Input.Root>
        <Input.Area
          id={name}
          hasError={!!error}
          mask={mask}
          variant="select"
          {...register(name)}
        />
        <Input.Label
          htmlFor={name}
          text={label}
          variant="select"
          hasError={!!error}
        />
        <Input.Span text={error} />
      </Input.Root>
    </Container>
  )
}
